
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import '../../../node_modules/core-js/modules/es.array.fill.js';
import '../../../node_modules/core-js/modules/es.array.map.js';
import '../../../node_modules/core-js/modules/es.array.reverse.js';
import '../../../node_modules/core-js/modules/es.array.slice.js';
import 'react';
import classNames from '../../../node_modules/classnames/index.js';
import Button from '../Button/Button.js';
import SvgChevronArrowLineLeft from '../../icons/chevrons/chevron-arrow-line-left.svg.js';
import SvgChevronArrowLineRight from '../../icons/chevrons/chevron-arrow-line-right.svg.js';
import SvgChevronArrowLeft from '../../icons/chevrons/chevron-arrow-left.svg.js';
import SvgChevronArrowRight from '../../icons/chevrons/chevron-arrow-right.svg.js';
import { container } from './styles.js';
import PaginationSelector from './components/PaginationSelector.js';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var _excluded = ["pageSize", "page", "translations", "a11yTranslations", "totalPages", "rowsPerPageOptions", "dir", "onPageChange", "onPageSizeChange", "listPlacement", "disabled"];
var Pagination = function Pagination(_ref) {
  var pageSize = _ref.pageSize,
    page = _ref.page,
    translations = _ref.translations,
    a11yTranslations = _ref.a11yTranslations,
    totalPages = _ref.totalPages,
    rowsPerPageOptions = _ref.rowsPerPageOptions,
    _ref$dir = _ref.dir,
    dir = _ref$dir === void 0 ? "ltr" : _ref$dir,
    onPageChange = _ref.onPageChange,
    onPageSizeChange = _ref.onPageSizeChange,
    _ref$listPlacement = _ref.listPlacement,
    listPlacement = _ref$listPlacement === void 0 ? "top" : _ref$listPlacement,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isRtl = dir === "rtl";
  var isPrevBtnDisabled = page === (isRtl ? totalPages : 1);
  var isNextBtnDisabled = page === (isRtl ? 1 : totalPages) || totalPages === 0;
  var handlePageSize = function handlePageSize(item) {
    onPageSizeChange(item);
  };
  var handlePageChange = function handlePageChange(item) {
    onPageChange(item);
  };
  var options = rowsPerPageOptions.slice().reverse();
  var optionItems = Array(totalPages).fill(0).map(function (_, i) {
    return {
      value: i + 1,
      label: "".concat(i + 1)
    };
  });
  var rtlClass = classNames({
    isRtl: isRtl
  });
  var paginationDirectionFactor = isRtl ? -1 : 1;
  var pageDirection = {
    firstPage: isRtl ? totalPages : 1,
    lastPage: isRtl ? 1 : totalPages,
    nextPage: page + paginationDirectionFactor,
    previousPage: page - paginationDirectionFactor
  };
  return jsx("div", _extends({
    css: function css(theme) {
      return container(theme);
    }
  }, rest, {
    className: rtlClass
  }), jsx("div", {
    className: "pagination-selector-wrapper",
    "data-testid": "pagination-per-page-btn"
  }, jsx(PaginationSelector, {
    items: options,
    selected: pageSize,
    listPlacement: listPlacement,
    ariaLabel: a11yTranslations.perPage,
    onClickItemHandler: handlePageSize,
    disabled: disabled
  }), jsx("span", null, translations.perPage)), jsx("div", {
    className: "pagination"
  }, jsx(Button, {
    className: "pagination-btn",
    "data-testid": "first-page-btn",
    title: translations.firstPage,
    onClick: function onClick() {
      return onPageChange(pageDirection.firstPage);
    },
    variant: "ghost",
    noGutters: true,
    disabled: isPrevBtnDisabled || disabled,
    "aria-label": a11yTranslations.firstPage
  }, jsx(SvgChevronArrowLineLeft, null)), jsx(Button, {
    className: "pagination-btn",
    "data-testid": "previous-page-btn",
    name: "Previous page",
    title: translations.previousPage,
    onClick: function onClick() {
      return onPageChange(pageDirection.previousPage);
    },
    variant: "ghost",
    noGutters: true,
    disabled: isPrevBtnDisabled || disabled,
    "aria-label": a11yTranslations.previousPage
  }, jsx(SvgChevronArrowLeft, null)), jsx("div", {
    className: "pagination-selector-wrapper",
    "data-testid": "pagination-page-selector-btn"
  }, jsx(PaginationSelector, {
    items: optionItems,
    selected: page,
    listPlacement: listPlacement,
    ariaLabel: a11yTranslations.ofPages,
    onClickItemHandler: handlePageChange,
    disabled: disabled
  }), totalPages > 1 && jsx("span", null, translations.ofPages, " ", totalPages)), jsx(Button, {
    className: "pagination-btn",
    "data-testid": "next-page-btn",
    name: "Next page",
    title: translations.nextPage,
    onClick: function onClick() {
      return onPageChange(pageDirection.nextPage);
    },
    variant: "ghost",
    noGutters: true,
    disabled: isNextBtnDisabled || disabled,
    "aria-label": a11yTranslations.nextPage
  }, jsx(SvgChevronArrowRight, null)), jsx(Button, {
    className: "pagination-btn",
    "data-testid": "last-page-btn",
    name: "Last page",
    title: translations.lastPage,
    onClick: function onClick() {
      return onPageChange(pageDirection.lastPage);
    },
    variant: "ghost",
    noGutters: true,
    disabled: isNextBtnDisabled || disabled,
    "aria-label": a11yTranslations.lastPage
  }, jsx(SvgChevronArrowLineRight, null))));
};

export { Pagination as default };
//# sourceMappingURL=Pagination.js.map
